/* ============================================================
   NORTHSHEEP — free gifts, put in the cart on their own

   Shopify's Buy X get Y discount can make a product free, but it cannot ADD
   it: the shopper has to have it in the cart already or the discount has
   nothing to act on. So this watches the cart and puts the gift in when the
   cart qualifies.

   TWO KINDS OF GIFT, ONE MACHINE
   A rule either asks "does the cart contain a qualifying product?"
   (mode: 'collection' — a brush with every sheepskin) or "is the cart worth
   enough?" (mode: 'threshold' — free slippers over €150, the Black Friday
   shape). Everything after that question is the same, and that sameness is
   the point: the behaviour below took a dozen bugs to get right and must not
   be reimplemented per campaign.

   WHAT IT READS
   window.NsGift.rules, written by snippets/ns-gift-data.liquid from theme
   settings. An empty rules list means the script is never even loaded. That
   is how the UK and Swiss stores run the brush, and how every store runs the
   campaign for the eleven months it is off.

   RULES THAT MATTER MORE THAN THE FEATURE
   1. If the shopper REMOVES a gift, it stays removed for the session. A gift
      that reappears every time you delete it is not a gift, it is a fight,
      and the shopper wins it by leaving.
   2. When the cart stops qualifying, the gift goes with it. Otherwise a cart
      with nothing but a brush in it reaches checkout, where the discount no
      longer applies and the shopper is charged for it.
   3. Gift lines never count toward a threshold. The brush sits in the cart at
      its full €9,95 until the checkout discount zeroes it, so counting it
      would let a free brush push someone over the line for free slippers —
      and the second gift would be charged for.

   The quantity is held at one. Shopify's discount would only zero the first
   anyway, so a second copy appears at full price — a nasty surprise at
   exactly the wrong moment.
   ============================================================ */
(function () {
  'use strict';
  if (window.__nsGift) return;
  window.__nsGift = true;

  var RULES = [];
  (((window.NsGift || {}).rules) || []).forEach(function (raw) {
    var variant = parseInt(raw.variant, 10) || 0;
    if (!variant) return;

    var rule = {
      key: String(raw.key || 'gift'),
      legacy: raw.legacy === true,
      /* Known by its variant alone, no `_gift` property on the line (the
         brush: never sold on its own, and the marker showed on every order
         in the admin). See ns-gift-data.liquid. */
      markless: raw.markless === true,
      /* Never a line in the basket: the parcel carries it, the basket shows a
         row (ns-gift-virtual-row.liquid) and the checkout a note on one
         qualifying line. See actVirtual(). */
      virtual: raw.virtual === true,
      noteName: String(raw.noteName || ''),
      noteValue: String(raw.noteValue || ''),
      mode: raw.mode === 'threshold' ? 'threshold' : 'collection',
      variant: variant,
      product: String(raw.product || ''),
      label: raw.label || '',
      collection: raw.collection || '',
      threshold: parseInt(raw.threshold, 10) || 0,
      qualify: {},
      exclude: {},
      /* Products that may not stay in the basket: the real brush while only
         its €0 copy is given away. See actClean(). */
      block: {},
      /* The brush row's stepper and bin (owner, 25 Sep 2026): the real
         brush's variant and product, and the order note an opt-out leaves.
         See onGiftStepper() and optOut(). */
      paid: parseInt(raw.paid, 10) || 0,
      paidProduct: raw.paidProduct ? String(raw.paidProduct) : '',
      optName: String(raw.optName || ''),
      optValue: String(raw.optValue || ''),
      /* Every variant of the gift, so a line can be recognised as this rule's
         gift whichever size the shopper chose. */
      variants: (raw.variants || []).filter(function (v) {
        return parseInt(v.id, 10);
      }),
      variantIds: {},
      /* Per rule, not global: a shopper who declines the brush should still be
         offered the campaign gift. */
      seen: null,
    };

    if (rule.mode === 'threshold' && rule.threshold <= 0) return;

    (raw.exclude || []).forEach(function (id) {
      rule.exclude[String(id)] = true;
    });

    (raw.block || []).forEach(function (id) {
      if (parseInt(id, 10)) rule.block[String(id)] = true;
    });

    /* Words that disqualify a product by its type or title — see the note in
       ns-gift-data.liquid. The server has already stripped these from the
       seed, exactly; this catches the ones that arrive from products.json,
       where a product's kind and template are not reported. */
    rule.excludeWords = (raw.excludeWords || [])
      .map(function (w) {
        return String(w || '').trim().toLowerCase();
      })
      .filter(Boolean);
    rule.seedIds = raw.ids || [];

    rule.variantIds[String(variant)] = true;
    rule.variants.forEach(function (v) {
      rule.variantIds[String(parseInt(v.id, 10))] = true;
    });

    /* A gift the shopper has to size is a gift this script must not add on
       its own. It offers the sizes instead — see the picker below. */
    rule.pick = rule.variants.length > 1;

    /* The old single-gift version used this key, so the brush keeps it. A
       shopper who declined a brush ten minutes before a theme update should
       not have it pushed back at them. */
    rule.declineKey = rule.legacy ? 'northsheep_gift_declined' : 'northsheep_gift_declined_' + rule.key;

    RULES.push(rule);
  });

  if (!RULES.length) return;

  function typeExcluded(rule, type) {
    if (!rule.excludeWords || !rule.excludeWords.length) return false;
    var t = String(type || '').toLowerCase();
    if (!t) return false;
    for (var i = 0; i < rule.excludeWords.length; i++) {
      if (t.indexOf(rule.excludeWords[i]) > -1) return true;
    }
    return false;
  }

  function qualifyAdd(rule, ids) {
    (ids || []).forEach(function (id) {
      var key = String(id);
      // The gift must never qualify for itself. It has happened: the brush was
      // still inside the sheepskin collection, so a cart holding nothing but a
      // brush asked for a free brush.
      if (key === rule.product) return;
      // A sheepskin that cannot be brushed earns no brush.
      if (rule.exclude[key]) return;
      rule.qualify[key] = true;
    });
  }

  RULES.forEach(function (rule) {
    if (rule.mode === 'collection') qualifyAdd(rule, rule.seedIds);
  });

  /* THE WHOLE COLLECTION, NOT THE FIRST FIFTY.

     Liquid hands out collection.products 50 at a time unless it is paginated,
     so the seed above is only the first page — on a 239-sheepskin store that
     silently meant most sheepskins earned no brush. products.json pages at
     250, and the answer is cached for the session: one request, and only on a
     page that has a cart.

     Nothing waits for this. The seed covers the first fifty immediately and
     the cart is re-checked when the full set lands. */
  function loadQualifying(rule) {
    if (rule.mode !== 'collection' || !rule.collection) return Promise.resolve();

    /* v3: the cached list from before reindeer were filtered out would go on
       handing out brushes for the rest of the session. v2 matched the TYPE
       against the local word only, and every store types its reindeer
       "Reindeer Hide": on DE/NL/FR none was caught (owner, 27 Sep 2026). */
    var cacheKey = 'northsheep_gift_ids3_' + rule.collection;

    try {
      var cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        qualifyAdd(rule, JSON.parse(cached));
        return Promise.resolve();
      }
    } catch (e) {
      /* no session storage: fetch every page load, still correct */
    }

    var ids = [];
    var page = 1;

    function fetchPage() {
      return fetch(root() + 'collections/' + rule.collection + '/products.json?limit=250&page=' + page)
        .then(function (r) {
          /* A refused page (429, 5xx) is not "no products": it used to be
             cached as an empty list for the whole session, and every sheepskin
             past the first fifty earned no brush (audit 2 Oct 2026). Nothing is
             cached; the next cart event tries again. */
          if (!r.ok) throw new Error('products.json ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var got = (data && data.products) || [];
          got.forEach(function (p) {
            // Type AND title: the type is English on every store, the title
            // is in the store's language.
            if (typeExcluded(rule, (p.product_type || '') + ' ' + (p.title || ''))) return;
            ids.push(p.id);
          });
          page++;
          // Four pages is a thousand products; past that something is wrong
          // with the collection, not with the gift.
          if (got.length === 250 && page <= 4) return fetchPage();
          qualifyAdd(rule, ids);
          try {
            sessionStorage.setItem(cacheKey, JSON.stringify(ids));
          } catch (e) {}
        });
    }

    return fetchPage().catch(function () {
      rule.listFailed = true;
    });
  }

  function loadAllQualifying() {
    return Promise.all(RULES.map(loadQualifying));
  }

  /* NOT ON AN EMPTY CART.

     The snippet prints how many items the cart held when the page was
     rendered. With none, there is nothing to check and nothing to qualify, so
     the opening /cart.js and products.json requests are skipped on every page
     a shopper browses before their first add. The first cart event (or add
     form submit) starts the same load-then-re-check that start() runs on a
     cart with items in it, once. An unknown count — a cached snippet from
     before the field existed — takes the old path. */
  var cartCount = (window.NsGift || {}).cartCount;
  var cartKnownEmpty = cartCount === 0;
  var qualifyingLoad = null;

  function loadQualifyingOnce() {
    if (!qualifyingLoad) {
      // The full qualifying set arrives after the first check; re-check then.
      qualifyingLoad = loadAllQualifying().then(function () {
        // A list that could not be fetched is asked for again on the next cart event.
        var failed = RULES.filter(function (r) {
          return r.listFailed;
        });
        failed.forEach(function (r) {
          r.listFailed = false;
        });
        if (failed.length) qualifyingLoad = null;
        return check();
      });
    }
    return qualifyingLoad;
  }

  var busy = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function declined(rule) {
    try {
      return sessionStorage.getItem(rule.declineKey) === '1';
    } catch (e) {
      return false;
    }
  }

  function undecline(rule) {
    try {
      sessionStorage.removeItem(rule.declineKey);
    } catch (e) {}
  }

  function decline(rule) {
    try {
      sessionStorage.setItem(rule.declineKey, '1');
    } catch (e) {
      /* private window: the gift simply comes back next add. Harmless. */
    }
  }

  /* WHICH LINE BELONGS TO WHICH RULE.

     The marker property carries the rule's name, so two gifts in one cart can
     each find their own line. Lines written by the single-gift version said
     `_gift: "true"`, which is why the brush rule also accepts that. */
  function isGiftLine(item, rule) {
    if (!item || !rule.variantIds[String(item.variant_id)]) return false;
    // A markless gift is its variant; lines added before still carry a mark and match too.
    if (rule.markless) return true;
    var mark = item.properties && item.properties._gift;
    if (!mark) return false;
    return mark === rule.key || (rule.legacy && mark === 'true');
  }

  function anyGiftLine(item) {
    for (var i = 0; i < RULES.length; i++) {
      if (isGiftLine(item, RULES[i])) return true;
    }
    return false;
  }

  /* The cart's worth, gifts excluded — see rule 3 at the top. */
  function payableTotal(cart) {
    var sum = 0;
    if (!cart || !cart.items) return sum;
    for (var i = 0; i < cart.items.length; i++) {
      if (anyGiftLine(cart.items[i])) continue;
      sum += cart.items[i].final_line_price || 0;
    }
    return sum;
  }

  function payableLines(cart) {
    var n = 0;
    if (!cart || !cart.items) return n;
    for (var i = 0; i < cart.items.length; i++) {
      if (!anyGiftLine(cart.items[i])) n++;
    }
    return n;
  }

  function qualifies(cart, rule) {
    if (!cart || !cart.items) return false;

    if (rule.mode === 'threshold') {
      /* A threshold gift on an empty cart would be a free order, so the cart
         has to hold something the shopper is actually paying for. */
      if (payableLines(cart) === 0) return false;
      return payableTotal(cart) >= rule.threshold;
    }

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (anyGiftLine(item)) continue;
      if (rule.qualify[String(item.product_id)]) return true;
    }
    return false;
  }

  /* RE-RENDER THE WAY DAWN DOES, WITH DAWN'S OWN LIST.

     The first version invented its own section refresh, and it left the cart
     half-updated: remove the last sheepskin and the gift went, but the drawer
     still said "1 ITEM" with a free-shipping bar for €9,95 and no rows —
     the brush was gone from the list and still in the totals.

     Two things were missing, and Dawn does both. It asks each cart element
     which sections IT needs (the drawer needs .drawer__inner and the bubble;
     the cart page needs the items, the footer, the live region), and it
     toggles `is-empty` on the drawer, the items element and the footer, which
     is what swaps in the "your cart is empty" state. Borrowing the list from
     the live element also means a theme change to it cannot leave this
     behind. */
  function host() {
    /* On the basket page, the page's own list. The drawer is rendered (closed)
       on every page, /cart included, so asking for it first redrew the hidden
       drawer: the page's subtotal stayed old after the brush's +/- and an
       emptied basket showed a blank page (audit 2 Oct 2026). */
    if (document.getElementById('main-cart-items')) {
      var page = document.querySelector('cart-items');
      if (page) return page;
    }
    return document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
  }

  function sectionList() {
    var h = host();
    if (h && typeof h.getSectionsToRender === 'function') {
      try {
        // CartItems' own version throws off the cart page (it reads
        // #main-cart-items directly), which is why this is guarded.
        return h.getSectionsToRender() || [];
      } catch (e) {
        return [];
      }
    }
    return [];
  }

  function apply(parsed, list) {
    if (!parsed || !parsed.sections) return;

    var empty = parsed.item_count === 0;
    var h = host();
    if (h) h.classList.toggle('is-empty', empty);
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', empty);
    var footer = document.getElementById('main-cart-footer');
    if (footer) footer.classList.toggle('is-empty', empty);

    list.forEach(function (section) {
      var container = document.getElementById(section.id);
      if (!container) return;
      var target = (section.selector && container.querySelector(section.selector)) || container;
      var html = parsed.sections[section.section || section.id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var source =
        (section.selector && doc.querySelector(section.selector)) || doc.querySelector('.shopify-section') || doc.body;
      if (source) target.innerHTML = source.innerHTML;
    });

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ns-gift', cartData: parsed });
    }
  }

  function post(url, body) {
    return fetch(root() + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      // A write landed: every basket read still out is older (see cartRead).
      seenSeq = readSeq + 1;
      return r.json();
    });
  }

  function add(rule, list, variantId) {
    var id = parseInt(variantId, 10) || rule.variant;
    var line = { id: id, quantity: 1 };
    if (!rule.markless) line.properties = { _gift: rule.key };
    var body = { items: [line] };
    /* Only ask for sections when there are some. An empty `sections` array is
       a 400 from Shopify — and because the failure still resolved as JSON, the
       script treated it as a successful add, remembered a gift that was never
       there, and then read its absence as the shopper refusing it. One brush
       short, for the rest of the session. */
    if (list && list.length) {
      body.sections = list.map(function (s) {
        return s.section || s.id;
      });
      body.sections_url = window.location.pathname;
    }
    return post('cart/add.js', body);
  }

  function setQuantity(key, quantity, list) {
    var body = { id: key, quantity: quantity };
    /* An empty `sections` array is a 400 from Shopify, so ask for none rather
       than for nothing — which is also how a size swap keeps the cart from
       being re-rendered halfway through. */
    if (list && list.length) {
      body.sections = list.map(function (s) {
        return s.section || s.id;
      });
      body.sections_url = window.location.pathname;
    }
    return post('cart/change.js', body);
  }

  var lastCart = null;

  /* Only a WHOLE cart may become the cached one. /cart/add.js answers with the
     line item it just added — not the cart — so caching its response left the
     click handler believing the cart held one brush and nothing else. It then
     found no line at the index being removed and stood aside, which is why
     the drawer still flickered long after the cart page stopped. */
  function remember(cart) {
    if (cart && cart.items && typeof cart.item_count === 'number') {
      // An answer overtaken by a newer read's (see cartRead) is not the basket any more.
      if (cart.__nsSeq) {
        if (cart.__nsSeq < seenSeq) return true;
        seenSeq = cart.__nsSeq;
      } else {
        // A basket handed over by a write's own answer: every read still out is older.
        seenSeq = readSeq + 1;
      }
      lastCart = cart;
      RULES.forEach(function (rule) {
        /* The "did the shopper remove it?" test reads this, so it may only
           ever be set from a cart the server actually described. It used to be
           set optimistically right after asking for the gift, which turned a
           failed add into a phantom refusal. */
        rule.seen = giftInCart(cart, rule);
        /* A cart that no longer qualifies is a clean slate: forget any
           refusal, so the next sheepskin brings a brush again. Without this a
           shopper who emptied their basket carried the refusal for the whole
           session. */
        if (!qualifies(cart, rule)) undecline(rule);
      });
      syncPdpGift(cart);
      return true;
    }
    return false;
  }

  /* THE PRODUCT PAGE'S BRUSH LINE FOLLOWS THE BASKET (owner, 25 Sep 2026: "if
     we can adjust it based on cart why not just hide it then from the product
     pages if the brush is already in"). A free brush already in the basket,
     or one the shopper took out (the opt-out note), means this sheepskin
     brings no brush of its own, and a line promising one read as "one brush
     per sheepskin". main-product.liquid renders it hidden in those cases;
     this keeps it right as the basket changes, without a reload. Called from
     remember(), so only ever with a whole cart. */
  function syncPdpGift(cart) {
    var els = document.querySelectorAll('[data-ns-pdp-gift]');
    if (!els.length) return;
    var rule = brushRule() || RULES[0];
    if (!rule) return;
    var hide = giftInCart(cart, rule) || optedOut(cart, rule);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (hide === el.hidden) continue;
      if (hide) {
        el.classList.add('is-leaving');
        setTimeout(hideAfterFade.bind(null, el), 220);
      } else {
        el.classList.remove('is-leaving');
        el.hidden = false;
      }
    }
  }

  function hideAfterFade(el) {
    if (!el.classList.contains('is-leaving')) return; // shown again meanwhile
    el.hidden = true;
    el.classList.remove('is-leaving');
  }

  /* ONE /cart.js, NOT TWO.

     start() calls check() and loadQualifyingOnce() in the same tick, and both
     ended up asking the server for the cart — two identical requests, on every
     page the shopper opens, measured on both a collection and a product page.

     That is not only a wasted round trip. Shopify sets the `cart` cookie on
     that response, and Chrome evicts a page from the back-forward cache when
     an HttpOnly cookie changes — so the page was being thrown out of the cache
     it had just entered, which is the "back works once, then reloads again"
     the owner reported.

     The in-flight PROMISE is shared, not the result: the pair fire in the same
     tick, so caching only the finished value would still let both requests go
     (the same trap noted in CLAUDE.md for loadAll()). It clears as soon as it
     settles, so every later read — after an add, a remove, a swap — is a fresh
     one, exactly as before.

     EXCEPT A READ STILL ON ITS WAY WHEN THE BASKET CHANGED (3 Oct 2026). On live
     DE the qualifying list's check read the basket a moment before Dawn's add
     landed (0 items); the add's own check, firing while that read was still out,
     was handed the same answer, saw an empty basket and added no brush (2 of 5
     adds). So a read made BECAUSE the basket changed (a cart event, after our
     own write) is `fresh`: it never takes a read that left before; it becomes
     the shared one for whoever asks next. */
  var cartInFlight = null;
  /* Each read is numbered; an answer overtaken by a newer read's answer is
     ignored (remember/evaluate), so the old empty basket cannot arrive last and
     become the cached one. */
  var readSeq = 0;
  var seenSeq = 0;
  function cartRead(fresh) {
    if (!cartInFlight || fresh) {
      var seq = ++readSeq;
      var mine = fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(
          function (c) {
            if (cartInFlight === mine) cartInFlight = null;
            if (c && typeof c === 'object') c.__nsSeq = seq;
            return c;
          },
          function (e) { if (cartInFlight === mine) cartInFlight = null; throw e; }
        );
      cartInFlight = mine;
    }
    return cartInFlight;
  }

  function rememberFromServer() {
    return cartRead(true)
      .then(remember)
      .catch(function () {});
  }

  function giftInCart(cart, rule) {
    if (!cart || !cart.items) return false;
    for (var i = 0; i < cart.items.length; i++) {
      if (isGiftLine(cart.items[i], rule)) return true;
    }
    return false;
  }

  function findGift(cart, rule) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (isGiftLine(cart.items[i], rule)) return cart.items[i];
    }
    return null;
  }

  /* One rule acts per pass, then the cart is read again.

     Two rules writing to the same cart in the same tick would each render the
     cart as it looked before the other's write, and the second render would
     paint away the first gift. Acting once and re-reading is a round trip
     slower in the rare case where both gifts land at once, and it is always
     correct. */
  function evaluate(cart) {
    if (busy || !cart || !cart.items) return;
    if (cart.__nsSeq && cart.__nsSeq < seenSeq) return; // overtaken (see cartRead)
    remember(cart);
    // A brush-row tap that came while a write was out (see onGiftStepper).
    if (queuedTotal !== null) {
      var total = queuedTotal;
      queuedTotal = null;
      return applyBrushTotal(total);
    }

    for (var r = 0; r < RULES.length; r++) {
      if (act(cart, RULES[r])) return;
    }
  }

  /* THE BRUSH IN THE PARCEL (owner, 24 Sep 2026). Shopify lets one item take
     part in only ONE Buy X get Y: a brush line with its own "buy a sheepskin"
     discount fought the 15% accessory offer over the same sheepskin, and one
     of the two silently dropped out (NL #A13040, DE #39365). A virtual gift is
     therefore never a line. This does two things only:
     1. takes out any real gift line (one left from before the switch, or one
        added by hand from the brush's own page) - it would be charged now;
     2. puts the checkout note ("Included: free brush") on ONE qualifying
        line, since the checkout lists only real lines. One per order, like
        the gift. */
  function actVirtual(cart, rule) {
    var stray = findGift(cart, rule);
    if (stray) {
      busy = true;
      var list = sectionList();
      setQuantity(stray.key, 0, list)
        .then(function (res) {
          remember(res);
          apply(res, list);
        })
        .catch(function () {})
        .then(function () {
          busy = false;
          settle();
        });
      return true;
    }
    if (!rule.noteName || rule.noteFailed) return false;

    var carrier = null;
    var candidate = null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.properties && it.properties[rule.noteName]) carrier = it;
      else if (!candidate && rule.qualify[String(it.product_id)]) candidate = it;
    }
    if (carrier || !candidate || !qualifies(cart, rule)) return false;

    var props = {};
    var own = candidate.properties || {};
    for (var k in own) {
      if (Object.prototype.hasOwnProperty.call(own, k)) props[k] = own[k];
    }
    props[rule.noteName] = rule.noteValue;

    busy = true;
    var list2 = sectionList();
    var body = { id: candidate.key, quantity: candidate.quantity, properties: props };
    if (list2.length) {
      body.sections = list2.map(function (s) {
        return s.section || s.id;
      });
      body.sections_url = window.location.pathname;
    }
    post('cart/change.js', body)
      .then(function (res) {
        /* An error payload carries `status`. Not retried on this page, or
           the settle() below would ask again, forever. */
        if (res && res.status) {
          rule.noteFailed = true;
          return;
        }
        remember(res);
        apply(res, list2);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        settle();
      });
    return true;
  }

  /* THE €0 GIFT (owner, 24 Sep 2026: "we create 2 brushes, 1 for 3.95 and
     one for 0 euro"). The gift is a free copy of the real brush, so the
     checkout shows it as a line without any discount fighting the 15% offers
     for the sheepskin. A basket started before that switch can hold two
     leftovers, and both would reach the order:
     1. the real brush, made free by a discount that is now off, so it would
        be charged; the €0 copy takes its place;
     2. the "Included: free brush" note from the evening the brush travelled
        as a note, which would announce the brush twice.
     One fix per pass, like everything else here, and never more than a few
     tries, so a request Shopify keeps refusing cannot loop. */
  function actClean(cart, rule) {
    rule.cleanTries = rule.cleanTries || 0;
    if (rule.cleanTries >= 4) return false;
    var i, it, target = null, props = null;

    for (i = 0; i < cart.items.length && !target; i++) {
      it = cart.items[i];
      if (rule.block[String(it.product_id)]) target = it;
    }

    if (!target && rule.noteName) {
      for (i = 0; i < cart.items.length && !target; i++) {
        it = cart.items[i];
        if (!it.properties || !it.properties[rule.noteName]) continue;
        target = it;
        /* BLANKED, NOT DROPPED. /cart/change.js ignores an empty properties
           object and replaces a non-empty one whole, so leaving the note out
           changes nothing. A blank value is what works: the checkout does not
           print it, and this test (above) no longer finds it. Measured on the
           example store, 24 Sep 2026. */
        props = {};
        for (var k in it.properties) {
          if (Object.prototype.hasOwnProperty.call(it.properties, k)) props[k] = it.properties[k];
        }
        props[rule.noteName] = '';
      }
    }
    if (!target) return false;

    rule.cleanTries++;
    busy = true;
    var list = sectionList();
    var body = { id: target.key, quantity: props ? target.quantity : 0 };
    if (props) body.properties = props;
    if (list.length) {
      body.sections = list.map(function (s) {
        return s.section || s.id;
      });
      body.sections_url = window.location.pathname;
    }
    post('cart/change.js', body)
      .then(function (res) {
        if (res && res.status) return;
        remember(res);
        apply(res, list);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        settle();
      });
    return true;
  }

  /* ONE ROW FOR EVERY BRUSH (owner, 25 Sep 2026: "add a qty selector and a
     bin to the free brush ... if they add a brush it adds the variant that
     actually cost 3.95" and "if people delete the free brush it ads me a
     notes in the orders").

     The cart templates draw the real brush's lines into the gift's row and
     give its stepper data-ns-gift-row. Its number is EVERY brush: one free
     plus the paid ones. So a change of that number becomes the paid line's
     quantity (the €0 line itself stays at one), and 0 is the shopper saying
     no to the brush: optOut(). Dawn never sees the event.

     An opt-out is written on the basket as a cart attribute, which reaches the
     order as "Additional details" in the admin. While it is there the gift is
     not added back, and the basket offers it back
     (ns-gift-restore-row.liquid), so the note that reaches an order is a
     choice, not a slip. */
  function brushRule() {
    for (var i = 0; i < RULES.length; i++) {
      if (RULES[i].paid && RULES[i].optName) return RULES[i];
    }
    return null;
  }

  function paidLines(cart, rule) {
    var out = [];
    if (!rule.paidProduct || !cart || !cart.items) return out;
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].product_id) === rule.paidProduct) out.push(cart.items[i]);
    }
    return out;
  }

  /* THE OPT-OUT NOTE WAS IN THE STORE'S LANGUAGE UNTIL 4 OCT 2026, then in
     English everywhere (owner: so it can be read while packing). A basket from
     before still carries one of these: it counts as the shopper's choice, is
     rewritten in the new words while the basket earns the brush
     (migrateOldNote) and cleared with the new one when it stops earning it. */
  var OLD_OPT_NAMES = ['Gratis Fellbürste', 'Gratis vachtborstel', 'Brosse offerte'];

  function optedOut(cart, rule) {
    if (!rule.optName || !cart || !cart.attributes) return false;
    if (cart.attributes[rule.optName]) return true;
    for (var i = 0; i < OLD_OPT_NAMES.length; i++) {
      if (cart.attributes[OLD_OPT_NAMES[i]]) return true;
    }
    return false;
  }

  function migrateOldNote(cart, rule) {
    if (!rule.optName || rule.noteMigrated || !cart || !cart.attributes) return false;
    var attrs = null;
    for (var i = 0; i < OLD_OPT_NAMES.length; i++) {
      var name = OLD_OPT_NAMES[i];
      if (name !== rule.optName && cart.attributes[name]) {
        attrs = attrs || {};
        attrs[name] = '';
      }
    }
    if (!attrs) return false;
    rule.noteMigrated = true;
    attrs[rule.optName] = rule.optValue;
    var list = sectionList();
    run(post('cart/update.js', withSections({ attributes: attrs }, list)), function (res) {
      if (!res || res.status) return;
      remember(res);
      apply(res, list);
    });
    return true;
  }

  function withSections(body, list) {
    if (list && list.length) {
      body.sections = list.map(function (s) {
        return s.section || s.id;
      });
      body.sections_url = window.location.pathname;
    }
    return body;
  }

  /* /cart/add.js answers with the added lines, not the basket: read the
     basket back before anything is re-rendered or published with it. */
  function applyAfterAdd(res, list) {
    if (!res || res.status) return check(true);
    return cartRead(true).then(function (cart) {
      remember(cart);
      var merged = {};
      for (var k in cart) {
        if (Object.prototype.hasOwnProperty.call(cart, k)) merged[k] = cart[k];
      }
      merged.sections = res.sections;
      apply(merged, list);
    });
  }

  function run(request, after) {
    busy = true;
    return request
      .then(after)
      .catch(function () {})
      .then(function () {
        busy = false;
        settle();
      });
  }

  function setNote(rule, value) {
    rule.noteTries = (rule.noteTries || 0) + 1;
    if (!rule.optName || rule.noteTries > 6) return false;
    var list = sectionList();
    var attrs = {};
    attrs[rule.optName] = value;
    // Clearing clears the old local wordings too (see OLD_OPT_NAMES).
    if (value === '') {
      OLD_OPT_NAMES.forEach(function (name) {
        if (name !== rule.optName) attrs[name] = '';
      });
    }
    run(post('cart/update.js', withSections({ attributes: attrs }, list)), function (res) {
      if (!res || res.status) return;
      rule.noteTries = 0;
      remember(res);
      apply(res, list);
    });
    return true;
  }

  function optOut(rule) {
    if (!lastCart) return check();
    var updates = {};
    var gift = findGift(lastCart, rule);
    if (gift) updates[gift.key] = 0;
    paidLines(lastCart, rule).forEach(function (l) {
      updates[l.key] = 0;
    });
    decline(rule);
    var list = sectionList();
    var body = withSections({ updates: updates }, list);
    body.attributes = {};
    body.attributes[rule.optName] = rule.optValue;
    run(post('cart/update.js', body), function (res) {
      if (!res || res.status) return;
      remember(res);
      apply(res, list);
    });
  }

  /* A TAP WHILE A WRITE IS OUT IS NOT DROPPED (4 Oct 2026 audit: a second
     quick + was ignored, and the box showed one brush more than the basket had
     - a box that posts nothing at checkout). The wanted total waits here and is
     applied once the write has landed (settle / evaluate). */
  var queuedTotal = null;

  function onGiftStepper(e) {
    var input = e.target;
    if (!input || !input.hasAttribute || !input.hasAttribute('data-ns-gift-row')) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    if (!brushRule()) return check(true);
    var total = parseInt(input.value, 10);
    if (isNaN(total) || total < 0) total = 1;
    if (!lastCart || busy) {
      queuedTotal = total;
      if (!busy) check(true);
      return;
    }
    applyBrushTotal(total);
  }

  function applyBrushTotal(total) {
    var rule = brushRule();
    if (!rule || !lastCart) return;
    if (total === 0) return optOut(rule);
    var want = total - 1;
    var lines = paidLines(lastCart, rule);
    var have = 0;
    lines.forEach(function (l) {
      have += l.quantity;
    });
    if (want === have) return;
    var list = sectionList();
    if (lines.length) {
      var updates = {};
      lines.forEach(function (l, i) {
        updates[l.key] = i === 0 ? want : 0;
      });
      run(post('cart/update.js', withSections({ updates: updates }, list)), function (res) {
        if (!res || res.status) return check();
        remember(res);
        apply(res, list);
      });
    } else {
      run(post('cart/add.js', withSections({ items: [{ id: rule.paid, quantity: want }] }, list)), function (res) {
        return applyAfterAdd(res, list);
      });
    }
  }

  function onRestore(e) {
    var btn = e.target.closest && e.target.closest('[data-ns-gift-restore]');
    if (!btn) return;
    e.preventDefault();
    var rule = brushRule();
    if (!rule || busy) return;
    undecline(rule);
    btn.disabled = true;
    var list = sectionList();
    var attrs = {};
    attrs[rule.optName] = '';
    run(
      post('cart/update.js', { attributes: attrs }).then(function () {
        return add(rule, list);
      }),
      function (res) {
        return applyAfterAdd(res, list);
      }
    );
  }

  function act(cart, rule) {
    if (rule.virtual) return actVirtual(cart, rule);
    if (actClean(cart, rule)) return true;
    var gift = findGift(cart, rule);
    var ok = qualifies(cart, rule);
    // An opt-out in the old local words, on a basket that still earns the brush: same choice, new words.
    if (ok && migrateOldNote(cart, rule)) return true;

    /* Read BEFORE deciding anything. The first version of this asked "was the
       gift here a moment ago and is it gone now?" at the END of the function —
       after the add below had already returned — so the question was never
       reached and a gift the shopper deleted came straight back. */
    var wasThere = rule.seen === true;
    rule.seen = !!gift;

    if (ok && !gift) {
      /* A sized gift is never added by this script — the shopper picks a size
         in the cart panel and `choose()` below does the adding. Nor is it
         declined: removing it is usually someone changing their mind about a
         size, and the panel should go on offering them. */
      if (rule.pick) return false;

      // Gone while the cart still qualifies: the shopper took it out. Once.
      if (wasThere) {
        decline(rule);
        // However it was taken out, the order should say so (the brush).
        if (rule.optName && !optedOut(cart, rule) && setNote(rule, rule.optValue)) return true;
        return false;
      }
      if (declined(rule) || optedOut(cart, rule)) return false;
      /* Refused once on this page (the gift sold out or unpublished, as on DE
         on 24 Sep 2026, or the store answering 429): not again until the next
         page. It used to retry add -> check -> add for as long as the page was
         open, 22 requests a second (audit 2 Oct 2026). */
      if (rule.refused) return false;
      // The head start is bringing it; it looks again once it has landed.
      if (headStart && headStart.rule === rule) return false;
      busy = true;
      var list = sectionList();
      add(rule, list)
        .then(function (res) {
          // A Shopify error payload carries `status`; nothing was added.
          if (res && res.status) {
            rule.refused = true;
            return;
          }
          apply(res, list);
          /* add.js answers with the line it added, not the cart. Reading the
             cart back is what records that the gift is now there — and the
             click handler that pairs a removal with the gift needs that copy,
             or it concludes there is no gift to pair with. */
          if (!remember(res)) return rememberFromServer();
        })
        .catch(function () {
          rule.refused = true;
        })
        .then(function () {
          busy = false;
          settle();
        });
      return true;
    }

    /* A basket that no longer earns the gift is a clean slate: the opt-out
       note goes too, so the next sheepskin brings a brush again. */
    if (!ok && optedOut(cart, rule) && setNote(rule, '')) return true;

    if (!ok && gift) {
      busy = true;
      /* Take it off the screen NOW. The request behind this is fast but not
         instant, and a gift sitting in a cart that no longer earns it — with
         the totals already updated around it — looks like a bug. The
         re-render that follows replaces the row properly; if the request
         fails, the next cart event puts it back. */
      var leaving = document.querySelectorAll('.cart-item--gift');
      for (var l = 0; l < leaving.length; l++) leaving[l].classList.add('is-leaving');
      // Nothing else in the cart: show the empty state without waiting.
      if (cart.items.length === 1) {
        var h0 = host();
        if (h0) h0.classList.add('is-empty');
        var d0 = document.querySelector('cart-drawer');
        if (d0) d0.classList.add('is-empty');
        var f0 = document.getElementById('main-cart-footer');
        if (f0) f0.classList.add('is-empty');
      }
      var removeList = sectionList();
      setQuantity(gift.key, 0, removeList)
        .then(function (res) {
          // We took it out, not the shopper — so this must not count as a
          // refusal, or re-adding the sheepskin would bring no gift.
          remember(res);
          apply(res, removeList);
        })
        .catch(function () {})
        .then(function () {
          busy = false;
          settle();
        });
      return true;
    }

    /* One SIZE only. A swap that failed between removing the old line and
       adding the new one can leave two, and two free pairs is a mistake the
       shopper has no reason to report. */
    if (gift) {
      for (var d = 0; d < cart.items.length; d++) {
        var dup = cart.items[d];
        if (dup === gift || !isGiftLine(dup, rule)) continue;
        busy = true;
        var dupList = sectionList();
        setQuantity(dup.key, 0, dupList)
          .then(function (res) {
            remember(res);
            apply(res, dupList);
          })
          .catch(function () {})
          .then(function () {
            busy = false;
            settle();
          });
        return true;
      }
    }

    // One only.
    if (gift && gift.quantity > 1) {
      busy = true;
      var oneList = sectionList();
      setQuantity(gift.key, 1, oneList)
        .then(function (res) {
          remember(res);
          apply(res, oneList);
        })
        .catch(function () {})
        .then(function () {
          busy = false;
          settle();
        });
      return true;
    }

    return false;
  }

  /* After one rule has acted, give every rule a look at the cart it left —
     the other rule's gift may now qualify, or a duplicate may still need
     clearing. The loop terminates because a pass that changes nothing writes
     nothing and so schedules nothing. */
  function settle() {
    if (queuedTotal !== null && lastCart && !busy) {
      var total = queuedTotal;
      queuedTotal = null;
      return applyBrushTotal(total);
    }
    check(true);
  }

  /* REMOVE BOTH IN ONE REQUEST.

     Letting Dawn remove the sheepskin and then taking the brush out after was
     correct but ugly: for a moment the cart held nothing but a €9,95 brush,
     so the free-shipping bar jumped to "only €65,05 away" over an empty list
     before the empty-cart message arrived. No amount of speed fixes that —
     it is a real state being painted.

     So when the click is on a line whose removal ends a gift's qualification,
     Dawn is stopped and every affected line goes in a single
     /cart/update.js. One request, one render, no cart that never really
     existed. For a threshold gift this matters more, not less: dropping under
     the threshold would otherwise show free slippers sitting in a cart that
     no longer earns them.

     Capture phase, because Dawn binds its own listener on the element; and
     only when a gift is actually affected, so every other removal is left
     alone. */
  function interceptRemove(e) {
    if (!lastCart || !lastCart.items) return;
    var btn = e.target.closest && e.target.closest('cart-remove-button');
    if (!btn) return;

    var line = parseInt(btn.getAttribute('data-index'), 10);
    if (!line) return;
    /* By the line's key first (see cart.js updateQuantity): a row drawn before
       the brush arrived still carries the number its line had then. */
    var key = btn.getAttribute('data-line-key');
    var item = null;
    for (var k = 0; key && k < lastCart.items.length; k++) {
      if (lastCart.items[k].key === key) item = lastCart.items[k];
    }
    /* A keyed row this script has not seen yet (added after its last read): its
       number belongs to another basket, so stand aside; cart.js removes it by
       its key (4 Oct 2026 audit: the bin on a just-added cushion could take the
       free brush instead). The number is only for rows drawn without a key. */
    if (!item) {
      if (key) return;
      item = lastCart.items[line - 1];
    }
    if (!item) return;

    /* The shopper removing a gift line is them declining it — that is rule 1,
       and it is handled by the evaluation, not here. Except the brush's bin:
       every brush in its row goes at once, and the order is told (optOut). */
    if (anyGiftLine(item)) {
      var br = brushRule();
      if (br && isGiftLine(item, br)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        optOut(br);
      }
      return;
    }

    var updates = {};
    var affected = 0;

    RULES.forEach(function (rule) {
      var gift = findGift(lastCart, rule);
      if (!gift) return;

      var stillQualifies;
      if (rule.mode === 'threshold') {
        stillQualifies =
          payableLines(lastCart) - 1 > 0 && payableTotal(lastCart) - (item.final_line_price || 0) >= rule.threshold;
      } else {
        if (!rule.qualify[String(item.product_id)]) return; // not a qualifying line for this rule
        var others = 0;
        for (var i = 0; i < lastCart.items.length; i++) {
          var it = lastCart.items[i];
          if (anyGiftLine(it)) continue;
          if (it !== item && rule.qualify[String(it.product_id)]) others++;
        }
        stillQualifies = others > 0;
      }

      if (stillQualifies) return;
      updates[gift.key] = 0;
      affected++;
    });

    if (!affected) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    busy = true;
    var list = sectionList();
    updates[item.key] = 0;
    post('cart/update.js', {
      updates: updates,
      sections: list.map(function (sec) {
        return sec.section || sec.id;
      }),
      sections_url: window.location.pathname,
    })
      .then(function (cart) {
        remember(cart);
        apply(cart, list);
      })
      .catch(function () {
        /* Something went wrong mid-flight: fall back to the slow path rather
           than leaving the shopper with a line that will not go. */
        check(true);
      })
      .then(function () {
        busy = false;
      });
  }

  /* ADD THE GIFT AT THE SAME MOMENT, NOT AFTER.

     The gift is a second write to the cart, so it can never be free — but it
     does not have to WAIT. It used to: Dawn added the sheepskin, rendered the
     drawer, published its event, and only then did this script ask for a
     brush, so the row arrived a few hundred milliseconds after the drawer had
     already opened without it.

     Now the form's submit starts the gift's request immediately, alongside
     Dawn's. Both hit the same cart; Dawn's sections are rendered after its own
     response, so the brush is usually already in the cart by then and appears
     in the very first paint of the drawer. When it loses the race, the check
     below notices the row is missing and renders it — the old behaviour, as
     the fallback rather than the rule.

     Only from a product page, where the product's id is knowable (Shopify's
     own analytics meta). A quick-add from a collection card carries no product
     id, so those keep the slower path.

     Only for collection rules, too. A threshold rule cannot know whether the
     cart will clear the threshold until the server has said what the line
     cost, so it takes the slower path by nature. */
  function metaProductId() {
    try {
      return String(window.ShopifyAnalytics.meta.product.id);
    } catch (e) {
      return '';
    }
  }

  function onSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    /* A page that opened on an empty cart has not loaded the qualifying set
       yet. Start it now, so it is usually in hand by the time Dawn's cart
       event arrives. */
    loadQualifyingOnce();
    if (busy || headStart) return;

    /* The product in THIS form's product block. After a colour or type swap
       the page's analytics still name the product the page opened on. A form
       outside a product block ("You may also like" card adds) gets no head
       start: the page's product is not what it adds (4 Oct 2026 audit). */
    var info = form.closest && form.closest('product-info[data-product-id]');
    var pid = info && info.getAttribute('data-product-id');
    if (!pid) return;

    /* ONLY WHEN A CART ALREADY EXISTS.

       Shopify keys the cart on a cookie. With no cart yet, two adds fired at
       once each CREATE one, and whichever Set-Cookie lands last wins — the
       other cart, with the other line in it, is orphaned. In testing that
       meant the shopper's sheepskin disappeared and the free brush was all
       that remained, which is about the worst way to lose a sale.

       So the head start is only taken when there is a cart to add to. On the
       first item of a session the gift follows a moment later, the way it did
       before. */
    if (!lastCart || !lastCart.token || lastCart.item_count === 0) return;

    for (var i = 0; i < RULES.length; i++) {
      var rule = RULES[i];
      if (rule.mode !== 'collection') continue;
      // A virtual gift is never added: nothing to start early.
      if (rule.virtual) continue;
      if (!rule.qualify[pid]) continue;
      if (declined(rule) || optedOut(lastCart, rule) || giftInCart(lastCart, rule)) continue;

      /* Dawn's own request is already on its way and will render the cart.
         This one only adds; see headStartDone() for what happens after. */
      var hs = { rule: rule, landed: false, dawn: false, late: false, timer: 0 };
      headStart = hs;
      hs.timer = setTimeout(function () {
        // Six seconds without both answers: look now, and again when it lands.
        hs.late = true;
        hs.landed = hs.dawn = true;
        headStartDone(hs);
      }, 6000);
      add(rule, [])
        .catch(function () {})
        .then(function () {
          if (hs.late) return check(true);
          hs.landed = true;
          headStartDone(hs);
        });
      return; // one head start per submit
    }
  }

  /* ONE HEAD START AT A TIME, AND NO OTHER BRUSH WHILE IT IS ON ITS WAY
     (DE #39652, 3 Oct 2026: two free brushes with one sheepskin). It used to
     be fire and forget. When it was slow, Dawn's add answered first, the
     check after it found no brush and added one, and then the head start
     landed too: two. Its follow-up only looked again when no brush row was
     showing, and by then one was, so nothing set it back to one while the
     drawer said "1". Reproduced on the example store with the head start held
     back 2.5 s: two free brushes in the basket, one in the drawer.

     Now act() leaves the adding to it, a second tap starts no second one, and
     once it has landed AND Dawn's add has answered, the basket is read again:
     evaluate() sets it right (one only; gone if the basket no longer earns
     it), and the row is drawn if the drawer was painted without it. */
  var headStart = null;

  function headStartDone(hs) {
    if (hs !== headStart || !hs.landed || !hs.dawn) return;
    clearTimeout(hs.timer);
    headStart = null;
    cartRead(true)
      .then(function (cart) {
        evaluate(cart);
        // Writing (busy) means a render follows anyway.
        if (busy || !giftInCart(cart, hs.rule) || document.querySelector('.cart-item--gift')) return;
        redraw(cart);
      })
      .catch(function () {});
  }

  /* Draw the basket as it is now: the sections Dawn's own list names, from
     Shopify's section rendering, with the cart that was just read. */
  function redraw(cart) {
    var list = sectionList();
    if (!list.length) return;
    var ids = list.map(function (s) {
      return s.section || s.id;
    });
    fetch(window.location.pathname + '?sections=' + ids.join(','), { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('sections ' + r.status);
        return r.json();
      })
      .then(function (sections) {
        var merged = {};
        for (var k in cart) {
          if (Object.prototype.hasOwnProperty.call(cart, k)) merged[k] = cart[k];
        }
        merged.sections = sections;
        apply(merged, list);
      })
      .catch(function () {});
  }

  /* THE SIZE PICKER — INLINE, NOT A POPUP.

     Slippers come in sizes, so the gift cannot simply appear. The obvious
     answer is a modal asking for a size, and it is the wrong one: a popup
     that interrupts someone on their way to checkout is a tax on the sale,
     and it is exactly what a shopper who dislikes popups will hold against
     the shop.

     So the sizes are a row of buttons in the panel that is already sitting in
     the cart. Nothing opens, nothing has to be dismissed, and choosing is one
     tap in the place the shopper is already looking.

     Changing size later is the same gesture. The old line is removed without
     asking for sections, so the cart is not re-rendered between the two
     requests — otherwise the panel would flash back to "choose your size"
     mid-swap and read as a failed click. */
  function ruleByKey(key) {
    for (var i = 0; i < RULES.length; i++) {
      if (RULES[i].key === key) return RULES[i];
    }
    return null;
  }

  function onPick(e) {
    var btn = e.target.closest && e.target.closest('[data-ns-gift-size]');
    if (!btn) return;
    e.preventDefault();
    if (busy || btn.disabled) return;

    var rule = ruleByKey(btn.getAttribute('data-ns-gift-rule') || '');
    var variantId = parseInt(btn.getAttribute('data-ns-gift-size'), 10);
    if (!rule || !variantId || !rule.variantIds[String(variantId)]) return;

    /* The cart may have changed since this row was rendered. Adding a gift to
       a cart that no longer earns one would put it through checkout at full
       price. */
    if (!lastCart || !qualifies(lastCart, rule)) {
      check();
      return;
    }

    var existing = findGift(lastCart, rule);
    if (existing && existing.variant_id === variantId) return; // already that size

    busy = true;
    btn.classList.add('is-busy');

    var list = sectionList();
    var first = existing ? setQuantity(existing.key, 0, []) : Promise.resolve();

    first
      .then(function () {
        return add(rule, list, variantId);
      })
      .then(function (res) {
        if (res && res.status) return;
        apply(res, list);
        if (!remember(res)) return rememberFromServer();
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        btn.classList.remove('is-busy');
        /* Read the cart back either way: a failed swap could have left the old
           line removed and no new one, and the panel has to show that. */
        check(true);
      });
  }

  /* DO NOT ANSWER THIS FROM THE SERVER-RENDERED CART. Tried on 21 Sep 2026
     and reverted the same hour.

     window.nsCartSnapshot holds every field this file reads, so feeding it to
     evaluate() looked like a free way to drop the opening /cart.js. It is not,
     and the reason is timing rather than data: check() is called from start()
     alongside loadQualifyingOnce(), and evaluate() can only judge whether the
     gift belongs in the basket once that qualifying set has arrived. The fetch
     took about a second, which is what gave the rules time to land.

     Answered synchronously, evaluate() ran against an empty rule set, decided
     the gift was missing and ADDED it — on every page load, to a basket that
     already contained it, then corrected itself with a /cart/change.js. A
     fresh collection page went from five requests to nine, two of them writes
     to the shopper's own cart.

     If the request is ever worth removing, the fix is to make evaluate() wait
     for the qualifying set, not to hand it the cart sooner. */
  // fresh: the basket has just changed, so no read that left before may answer (see cartRead).
  function check(fresh) {
    cartRead(fresh)
      .then(evaluate)
      .catch(function () {});
  }

  /* THE GIFT BADGE HUGS ITS WORDS (owner, 25 Sep 2026: "make this beige
     block smaller ... size the box based on the text because each country
     has a different length of text"). A label that wraps makes its box as
     wide as the room it was given, not as its longest line, and CSS has no
     way to shrink it back. So: measure the lines and give the words the
     longest one's width. A label on one line already fits and keeps no
     width. Only the width changes, never the line breaks or the height.
     Run when a basket is drawn (load, every drawer or cart re-render, fonts
     arriving) and after a resize.

     A WORD CUT IN TWO IS WORSE THAN A WIDE BOX. The drawer's text column on
     a 375px phone is ~94px and "SCHAPENVACHT" ~100px, so it printed
     "SCHAPENVACH / T". Hyphenation cannot be relied on (not every browser
     has the dictionaries, and capitals often are not hyphenated). So when a
     word is cut, that badge is set tighter (is-tight: less letter-spacing),
     and if a word is still cut, without its icon (is-tighter). */
  function cutWord(el) {
    var node = el.firstChild;
    if (!node || node.nodeType !== 3) return false;
    var re = /\S+/g;
    var m;
    while ((m = re.exec(node.data))) {
      var r = document.createRange();
      r.setStart(node, m.index);
      r.setEnd(node, m.index + m[0].length);
      if (r.getClientRects().length > 1) return true;
    }
    return false;
  }

  function fitBadges() {
    var list = document.querySelectorAll('.ns-cart-gift-badge__text');
    if (!list.length) return;
    var i;
    // Reset all, then read all, then write all: one layout per step, not one per badge.
    for (i = 0; i < list.length; i++) {
      list[i].style.width = '';
      list[i].parentNode.classList.remove('is-tight', 'is-tighter');
    }
    ['is-tight', 'is-tighter'].forEach(function (step) {
      var cut = [];
      for (var k = 0; k < list.length; k++) if (cutWord(list[k])) cut.push(list[k]);
      cut.forEach(function (el) {
        el.parentNode.classList.add(step);
      });
    });
    var widths = [];
    for (i = 0; i < list.length; i++) {
      var range = document.createRange();
      range.selectNodeContents(list[i]);
      var rects = range.getClientRects();
      var widest = 0;
      if (rects.length > 1) {
        for (var j = 0; j < rects.length; j++) widest = Math.max(widest, rects[j].width);
      }
      widths.push(widest);
    }
    for (i = 0; i < list.length; i++) {
      if (widths[i] > 0) list[i].style.width = Math.ceil(widths[i]) + 1 + 'px';
    }
  }

  function watchBadges() {
    fitBadges();
    /* Dawn redraws the drawer and the cart page by replacing their insides,
       which drops the width. Only added nodes are watched: this writes a
       style attribute, which it must not see (it would feed itself). */
    if (typeof MutationObserver === 'function') {
      var mo = new MutationObserver(fitBadges);
      ['cart-drawer', '#main-cart-items'].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (el) mo.observe(el, { childList: true, subtree: true });
      });
    }
    var resizeTimer = 0;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(fitBadges, 120);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitBadges);
  }

  function start() {
    /* AN EMPTY BASKET IS A CLEAN SLATE TOO (24 Sep 2026, order #39363: two
       sheepskins, no brush). remember() forgets a refusal when it SEES a cart
       that no longer qualifies - but a page that opens on an empty cart skips
       the first read (below), so a refusal from earlier in the session (a tab
       kept open overnight, the old theme's brush used the same key) survived,
       and the next sheepskin found "declined" and brought no brush. An empty
       basket cannot hold a refusal worth keeping: forget it here, no request. */
    if (cartKnownEmpty) RULES.forEach(undecline);
    /* The free-brush opt-out note belongs to the basket it was made in. On an
       empty basket it is a leftover (the basket was emptied on a page that
       never told us), and it would keep the brush from the next sheepskin. */
    if (cartKnownEmpty && (window.NsGift || {}).optOutSet) {
      var br0 = brushRule();
      if (br0) setNote(br0, '');
    }
    if (!cartKnownEmpty) {
      check();
      loadQualifyingOnce();
    }
    document.addEventListener('click', interceptRemove, true);
    document.addEventListener('click', onPick);
    // The brush row's stepper, before Dawn's own change handler sees it.
    document.addEventListener('change', onGiftStepper, true);
    document.addEventListener('click', onRestore);
    document.addEventListener('submit', onSubmit, true);
    watchBadges();
    /* A page Safari hands back from its back-forward cache runs no script
       again, and its basket may have changed on the page in between: read it,
       so the brush line (syncPdpGift) and the gift itself match it. */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) check();
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        // Not our own echo, or it loops.
        if (event && event.source === 'ns-gift') return;
        // Dawn's add has answered: half of what a head start waits for.
        if (headStart && event && event.source === 'product-form') {
          headStart.dawn = true;
          headStartDone(headStart);
        }
        // First cart event on a page that opened empty: load the full set and
        // re-check when it lands, exactly as start() does on a non-empty cart.
        loadQualifyingOnce();
        /* Dawn hands the new cart along with the event, so read THAT rather
           than asking the server what just happened. It saves a round trip,
           which is most of the pause between "I removed the sheepskin" and
           "the brush went with it". */
        var data = event && event.cartData;
        // Only a WHOLE basket (an add's answer lists just the added lines).
        if (data && data.items && typeof data.item_count === 'number') {
          evaluate(data);
          return;
        }
        // A write landed without handing the basket over: every read still out is older.
        seenSeq = readSeq + 1;
        check(true);
      });
      if (PUB_SUB_EVENTS.cartError) {
        subscribe(PUB_SUB_EVENTS.cartError, function (event) {
          /* A refused add (sold out: 422) is Dawn's answer too, so a head start
             stops waiting for it and its brush is set right at once (4 Oct 2026
             audit: it used to wait out the 6 s timer). */
          if (headStart && event && event.source === 'product-form') {
            headStart.dawn = true;
            headStartDone(headStart);
          }
        });
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
